import Cookies from 'js-cookie';

const STORAGE_KEY = 'edu_progress';
const COOKIE_OPTS = { expires: 365, path: '/', sameSite: 'Lax' };

export function maybeResetEduCookies() {
  if (Cookies.get('edu_init') || localStorage.getItem('edu_init')) return;
  Cookies.remove('edu_completed', { path: '/' });
  Cookies.remove('edu_in_progress', { path: '/' });
  localStorage.removeItem(STORAGE_KEY);
  Cookies.set('edu_init', '2', COOKIE_OPTS);
  localStorage.setItem('edu_init', '2');
}

export function getProgress() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || defaultProgress();
  } catch {
    // localStorage unavailable or JSON malformed — return clean state
    return defaultProgress();
  }
}

export function saveProgress(progress) {
  // eslint-disable-next-line camelcase
  const updated = { ...progress, updated_at: new Date().toISOString() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  syncProgressCookie(updated);
  return updated;
}

function syncProgressCookie(progress) {
  const completed = (progress.completed_topics || []).join(',');
  const inProgress = (progress.in_progress_topics || []).join(',');
  Cookies.set('edu_completed', completed, { expires: 365, path: '/', sameSite: 'Lax' });
  Cookies.set('edu_in_progress', inProgress, { expires: 365, path: '/', sameSite: 'Lax' });
}

export function defaultProgress() {
  return {
    // eslint-disable-next-line camelcase
    completed_topics: [],
    // eslint-disable-next-line camelcase
    in_progress_topics: [],
    // eslint-disable-next-line camelcase
    completed_lessons: [],
    // eslint-disable-next-line camelcase
    last_topic_id: 0,
    // eslint-disable-next-line camelcase
    last_topic_url: '',
    // eslint-disable-next-line camelcase
    started_at: new Date().toISOString(),
    // eslint-disable-next-line camelcase
    updated_at: new Date().toISOString()
  };
}
